import { useEffect } from 'react';

export interface SEOData {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
}

export function useSEO(data: SEOData) {
  useEffect(() => {
    document.title = data.title;

    const setMeta = (name: string, content: string, property = false) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', data.description);
    setMeta('keywords', data.keywords);
    setMeta('og:title', data.title, true);
    setMeta('og:description', data.description, true);
    setMeta('og:type', data.ogType || 'website', true);
    setMeta('og:url', data.canonicalUrl, true);
    if (data.ogImage) {
      setMeta('og:image', data.ogImage, true);
    }
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', data.title);
    setMeta('twitter:description', data.description);

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', data.canonicalUrl);
  }, [data]);
}

export function SchemaOrg({ data }: { data: Record<string, unknown> }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data, null, 2) }}
    />
  );
}